module.exports = __webpack_public_path__ + "media/images/permanent-roles-gray-3d90f3d00a96a411c43183c1ca300ed6.svg";